<template>
  <div ref="home" class="home">
    <!-- 导航栏 -->
    <Header></Header>
    <!-- banner栏 -->
    <div class="banner">
      <div class="bannerText">
        <div>
          <h3>互联网APP</h3>
          <p>兼 顾 性 能 和 安 全</p>
        </div>
      </div>
      <div class="bannerImg">
        <img :src="baseImgUrl + '/u/20230108/互联网bg_1673181659467.jpg'">
      </div>
    </div>
    <!-- 行业现状 -->
    <div>
      <div class="currencyTitle">
        <img :src="baseImgUrl + '/u/20230108/logoTitle_1673179686356.png'">
        <h3>行业现状</h3>
      </div>
      <div class="tagsBox">
        <ul>
          <li class="li_style_01">用户投诉率上升</li>
          <li class="li_style_02">网络传输不稳定</li>
          <li class="li_style_03">用户个人隐私泄露</li>
          <li class="li_style_04">业务卡顿</li>
          <li class="li_style_05">黑客攻击</li>
          <li class="li_style_06">网络速度不佳</li>
          <li class="li_style_07">高丢包率</li>
          <li class="li_style_08">用户掉线</li>
          <li class="li_style_09">存在安全风险</li>
          <li class="li_style_10">经常更换线路</li>
          <li class="li_style_11">网络高延时</li>
          <li class="li_style_12">不注重用户体验</li>
          <li class="li_style_13">经常调整IDC位置</li>
        </ul>
        <div :style="{backgroundImage:'url('+ bgUrl +')'}">
          <p>随着线上业务的崛起，各行业对网络速度及用户体验要求日趋升高，期待持续稳定的网络传输质量来保证用户体验。在网络高延时、高丢包率、造成业务卡顿、用户掉线等情况下，只能经常更换线路，甚至调整IDC位置，或者使用APM和云拨测等监测服务来作为基础方案，但网络性能却始终达不到理想要求，用户投诉率居高不下。于此同时，线上业务访问端口的开放也会带来相应的安全风险和用户个人隐私泄露风险，特别是手机端APP也愈发成为黑客的重点攻击对象。</p>
        </div>
      </div>
    </div>
    <!-- 行业痛点分析 -->
    <div>
      <div class="currencyTitle">
        <img :src="baseImgUrl + '/u/20230108/logoTitle_1673179686356.png'">
        <h3>行业痛点分析</h3>
      </div>
      <div class="painBox">
        <ul>
          <li>
            <img :src="baseImgUrl + '/u/20230108/%E6%80%A7%E8%83%BD_1673183358471.png'" alt="">
            <h4>网络性能</h4>
            <p>登录卡顿，浏览白屏，使用体验差</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230108/安全_1673183358465.png'" alt="">
            <h4>网络安全</h4>
            <p>漏扫和渗透，零日漏洞，高级持久威胁APT</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230108/%E6%B5%81%E9%87%8F_1673183358469.png'" alt="">
            <h4>突发大流量</h4>
            <p>访问量突增，线上促销，源站宕机</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230108/风险_1673183358467.png'" alt="">
            <h4>业务风险</h4>
            <p>广告虚假点击，薅羊毛，作弊</p>
          </li>
        </ul>
      </div>
    </div>
     <!-- 我们提供的解决方案 -->
    <div>
      <div class="currencyTitle">
        <img :src="baseImgUrl + '/u/20230108/logoTitle_1673179686356.png'">
        <h3>我们提供的解决方案</h3>
      </div>
      <div class="planBox">
        <div class="planBoxL">
          <h4>兼顾性能和安全</h4>
          <p>将线上业务平台纳入优质的网络即服务（NaaS）中，为业务平台的安全和速度保驾护航，将一切恶意流量攻击和渗透窃取等行为拒之门外，用户APP利用自己的就近接入节点无感知的稳定高质量访问并拥有流畅使用体验。还可配合风险设备查询对用户的登陆身份进行安全性查验，为用户营造健康的使用氛围。</p>
          <span><i>75% </i>的企业同意升级网络框架简化IT</span>
        </div>
        <div class="planBoxR">
          <img :src="baseImgUrl + '/u/20230108/合作_1673183969662.jpg'">
        </div>
      </div>
    </div>
    <!-- 我们拥有的技术优势 -->
    <div class="companyDo">
      <div class="currencyTitle currencyTitleTip">
        <img :src="baseImgUrl + '/u/20230108/logoTitle_1673179686356.png'">
        <h3>我们拥有的技术优势</h3>
      </div>
      <div class="companyDo_inner">
        <h5>新一代综合考虑网络性能、网络安全、自动化运维的产品方案，可以在任何范围内高速稳定访问应用程序、互联网和数据中心, 具有免疫所有网络攻击的特点</h5>
        <div class="companyDo_innerB">
          <ul>
            <li>
              <span>01</span>
              <h4>网络性能</h4>
              <p>分布式流控<br />节点自动伸缩<br />网络层协议优化<br />全链路传输质量保证</p>
            </li>
            <li>
              <span>02</span>
              <h4>网络安全</h4>
              <p>隐藏源站<br />免疫所有网络攻击<br />高可伸缩<br />分布式主动防御</p>
            </li>
            <li>
              <span>03</span>
              <h4>移动安全</h4>
              <p>零信任安全一体化<br />设备威胁感知<br />高安全运行环境检测<br />支持国密通讯协议加密</p>
            </li>
            <li>
              <span>04</span>
              <h4>全方位态势感知</h4>
              <p>实时告警/详情审计<br />威胁自动处理<br />场景智能识别<br />态势感知和管控</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="styleBox_07" :style="{backgroundImage:'url('+ bgUrl2 +')'}">
      <p>智能化网络安全保障服务，即刻开启！</p>
      <a href="#" class="comButton collection-1 btn-15"><span>立即定制</span></a>
    </div>
    <!-- 侧边栏 -->
    <Sidebar></Sidebar>
    <!-- 底部页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    return {
      baseImgUrl: '',
      bgUrl: '',
      bgUrl2: ''
    }
  },
  methods: {

  },
  mounted () {
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230108/world-g15e6e7726_1920_1673182998704.jpg'
    this.bgUrl2 = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
  }
}
</script>
<style lang="less" scoped>

// 移动端样式
@media only screen and (max-width: 1024px) {

}
// pc端样式
@media only screen and (min-width: 1024px) {
  .home{
    width: 100%;
    // 按钮样式
    // banner图部分
    .banner{
      position: relative;
      .bannerText{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        div{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3{
            font-size: 52px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 78px;
            letter-spacing: 5px;
            text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
            padding: 16px 51px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            margin-bottom: 37px;
          }
          p{
            font-size: 30px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 42px;
            letter-spacing: 2px;
          }
        }
      }
      .bannerImg{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .comButton{
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
      height: 50px;
    }
    .btn-15:after{
      background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
    }
    // 通用标题
    .currencyTitle{
      display: flex;
      justify-content: center;
      margin: 110px 0 85px 0;
      img{
        width: 69px;
        height: 54px;
      }
      h3{
        color: #08142A;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-left: 22px;
      }
    }
    .tagsBox{
      max-width: 1180px;
      margin: 0 auto;
      ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        li{
          padding: 14px 42px;
          border-radius: 28px;
          background: #F3F3F3;
          margin-bottom: 18px;
          margin-right: 46px;
        }
        .li_style_01{
          background: #F3F3F3;
          border-radius: 28px;
          padding: 15px 40px;
          font-size: 18px;
          color: #4C5461;
        }
        .li_style_02{
          background: #F3F3F3;
          border-radius: 28px;
          padding: 14px 38px;
          font-size: 16px;
          color: #4C5461;
        }
        .li_style_03{
          font-size: 18px;
          font-weight: 600;
          color: #FFFFFF;
          padding: 14px 42px;
          background: linear-gradient(222deg, #3EE3FF 0%, #2E9EFD 46%, #186AE8 100%);
        }
        .li_style_04{
          font-size: 18px;
          font-weight: 600;
          color: #4C5461;
          padding: 16px 55px;
          background: #F3F3F3;
        }
        .li_style_05{
          font-size: 18px;
          font-weight: 500;
          color: #4C5461;
          padding: 13px 45px;
          background: #EEEEEE;
        }
        .li_style_06{
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          background: linear-gradient(222deg, #3EE3FF 0%, #2E9EFD 46%, #186AE8 100%);
          padding: 14px 48px;
        }
        .li_style_07{
          font-size: 20px;
          font-weight: 500;
          color: #4C5461;
          padding: 14px 47px;
          background: #F3F3F3;
        }
        .li_style_08{
          font-size: 16px;
          font-weight: 500;
          color: #4C5461;
          padding: 14px 46px;
          background: #F3F3F3;
        }
        .li_style_09{
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
          padding: 14px 43px;
          background: linear-gradient(222deg, #3EE3FF 0%, #2E9EFD 46%, #186AE8 100%);
        }
        .li_style_10{
          font-size: 18px;
          font-weight: 500;
          color: #4C5461;
          padding: 16px 37px;
          background: #F3F3F3;
        }
        .li_style_11{
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
          padding: 14px 41px;
          background: linear-gradient(222deg, #3EE3FF 0%, #2E9EFD 46%, #186AE8 100%);
        }
        .li_style_12{
          font-size: 16px;
          font-weight: 500;
          color: #4C5461;
          padding: 14px 38px;
          background: #F3F3F3;
        }
        .li_style_13{
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          padding: 16px 44px;
          background: linear-gradient(222deg, #3EE3FF 0%, #2E9EFD 46%, #186AE8 100%);
        }
      }
      div{
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding:71px 158px;
        box-sizing: border-box;
        max-width: 1180px;
        margin: 0 auto;
        margin-top: 55px;
        p{
          font-size: 16px;
          font-weight: 300;
          color: #4C5461;
          line-height: 30px;
        }
      }
    }
    .painBox{
      max-width: 1180px;
      margin: 0 auto;
      ul{
        display: flex;
        justify-content: space-between;
        li{
          width: 24%;
          background: #FFFFFF;
          box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
          border-radius: 24px;
          padding: 40px 30px;
          box-sizing: border-box;
          border-bottom: 6px solid #428BF8;
          img{
            width: 60px;
            height: 61px;
            margin-bottom: 26px;
          }
          h4{
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: 600;
            color: #353535;
          }
          p{
            font-size: 16px;
            font-weight: 300;
            color: #4C5461;
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
          }
        }
      }
    }
    .planBox{
      max-width: 1180px;
      margin: 0 auto;
      padding: 60px 64px;
      border-radius: 24px;
      background: #FFFFFF;
      box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
      display: flex;
      justify-content: space-between;
      .planBoxL{
        width: 496px;
        h4{
          font-size: 30px;
          font-weight: 600;
          color: #3687FF;
          line-height: 42px;
          letter-spacing: 1px;
        }
        p{
          font-size: 17px;
          font-weight: 300;
          color: #4C5461;
          line-height: 30px;
          margin: 48px 0 48px;
        }
        span{
          line-height: 45px;
          letter-spacing: 1px;
          color: #08142A;
          font-weight: 600;
          font-size: 22px;
          i{
            font-size: 30px;
            font-weight: 600;
            color: #3687FF;
          }
        }
      }
      .planBoxR{
        width: 498px;
        img{
          width: 100%;
        }
      }
    }
    .companyDo{
      width: 100%;
      .companyDo_inner{
        background-image:url('../assets/images/img_teams.jpg');
        background-repeat:  no-repeat;
        padding-bottom: 106px;
        h5{
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          width: 760px;
          margin: 0 auto;
          padding: 70px 0 75px;
          line-height:35px;
        }
        .companyDo_innerB{
          max-width: 1180px;
          margin: 0 auto;
          ul{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
              position: relative;
              width: 270px;
              padding: 96px 38px 73px;
              box-sizing: border-box;
              border-radius: 20px;
              box-shadow: 0px 2px 12px 0px rgba(204,204,204,0.5);
              background: #fff;
              margin-bottom: 24px;
              span{
                position: absolute;
                right: 28px;
                top: 32px;
                color: #90BFF7;
                font-size: 30px;
                font-weight: bold;
              }
              h4{
                font-size: 22px;
                font-weight: 600;
                color: #353535;
                margin-bottom: 16px;
              }
              p{
                font-size: 16px;
                font-weight: 300;
                color: #4C5461;
                line-height: 26px;
              }
            }
          }
        }
      }
    }
    .styleBox_07 {
      width: 100%;
      height: 320px;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .styleBox_07 p {
      font-size: 32px;
      font-weight: 600;
      color: #08142A;
      margin-bottom: 44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue